export enum TransactionStatus {
  COMPLETED = "completed",
  REJECTED = "rejected",
}
